import { render } from "./projects.vue?vue&type=template&id=59442506&scoped=true"
import script from "./projects.vue?vue&type=script&lang=js"
export * from "./projects.vue?vue&type=script&lang=js"

import "./projects.vue?vue&type=style&index=0&id=59442506&lang=css"
import "./projects.vue?vue&type=style&index=1&id=59442506&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59442506"]])

export default __exports__